import { ISO_DATE } from '@/utils/dateFormats';
import moment from 'moment';

function formatDate(date) {
  if (!date) {
    return '';
  }

  return moment.utc(date).format('DD/MM/YYYY') !== 'Invalid date'
    ? moment.utc(date).format('DD/MM/YYYY')
    : '';
}

function formatDateTime(date) {
  if (!date) {
    return '';
  }
  return moment(date.value).format('DD/MM/YYYY HH:mm') !== 'Invalid date'
    ? moment(date.value).format('DD/MM/YYYY HH:mm')
    : '';
}

function formatDateUSA(date) {
  if (!date) {
    return '';
  }
  return moment(date.value).format(ISO_DATE) !== 'Invalid date'
    ? moment(date.value).format(ISO_DATE)
    : '';
}

export { formatDate, formatDateTime, formatDateUSA };
